/**
 * @generated SignedSource<<e6403d69b19f8f68e41d548e00c69778>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountInformation_viewer$data = {
  readonly avatarURL: string;
  readonly " $fragmentType": "AccountInformation_viewer";
};
export type AccountInformation_viewer$key = {
  readonly " $data"?: AccountInformation_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountInformation_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountInformation_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarURL",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "50b44ede39de90bed5b4e969ada3019b";

export default node;
